import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "menu-bar__actions is-flex is-flex--align-center" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["disabled"]

import type { Editor } from '@tiptap/vue-3'
import { ref } from 'vue'
import BoldIcon from 'components/icons/bold/index.vue'
import ItalicIcon from 'components/icons/italic/index.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'EditorToolbar',
  props: {
    editor: {},
    class: {}
  },
  setup(__props: any) {

const props = __props

const linkInput = ref('')
const isLinkPopoverShown = ref(false)

const setLink = () => {
  props.editor.chain().focus().extendMarkRange('link').setLink({ href: linkInput.value }).run()
  isLinkPopoverShown.value = false
}

const handleLinkBtnClick = () => {
  if (props.editor.isActive('link')) {
    props.editor.chain().focus().unsetLink().run()
    return
  }

  const { view, state } = props.editor
  const { from, to } = view.state.selection
  const selectedText = state.doc.textBetween(from, to, '')

  if (selectedText) {
    linkInput.value = selectedText
    isLinkPopoverShown.value = true
  }
}

return (_ctx: any,_cache: any) => {
  return (props.editor)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["menu-bar", _ctx.class])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("button", {
            type: "button",
            "aria-label": "Bold",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editor.chain().focus().toggleBold().run())),
            disabled: !_ctx.editor.can().chain().focus().toggleBold().run(),
            class: _normalizeClass(["mt-button is-ghost customTooltip", { 'is-active': _ctx.editor.isActive('bold') }])
          }, [
            _createVNode(BoldIcon, {
              width: "22px",
              height: "22px"
            })
          ], 10, _hoisted_2),
          _createElementVNode("button", {
            type: "button",
            "aria-label": "Italic",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editor.chain().focus().toggleItalic().run())),
            disabled: !_ctx.editor.can().chain().focus().toggleItalic().run(),
            class: _normalizeClass(["mt-button is-ghost customTooltip", { 'is-active': _ctx.editor.isActive('italic') }])
          }, [
            _createVNode(ItalicIcon, {
              width: "22px",
              height: "22px"
            })
          ], 10, _hoisted_3)
        ])
      ], 2))
    : _createCommentVNode("", true)
}
}

})